/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnSessionUpdateStrategy } from './en-session-update-strategy';
import { EnShared } from './en-shared';
import { JoinEntityDto } from './join-entity-dto';
import { UpdateSessionExerciseDto } from './update-session-exercise-dto';
 /**
 *
 *
 * @export
 * @interface UpdateSessionDto
 */
export interface UpdateSessionDto {

    /**
     * @type {number}
     * @memberof UpdateSessionDto
     */
    laps: number;

    /**
     * Rest between laps. If 0 Unity must use `SessionExercise.rest` (rest between sets)
     *
     * @type {number}
     * @memberof UpdateSessionDto
     */
    rest: number;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateSessionDto
     */
    mobility: JoinEntityDto;

    /**
     * @type {boolean}
     * @memberof UpdateSessionDto
     */
    isTemplate?: boolean;

    /**
     * @type {EnShared}
     * @memberof UpdateSessionDto
     */
    shared?: EnShared;

    /**
     * @type {string}
     * @memberof UpdateSessionDto
     */
    note?: string | null;

    /**
     * @type {string}
     * @memberof UpdateSessionDto
     */
    title?: string;

    /**
     * What to do with the events already scheduled from this session. When the session is referenced and this is omitted, the request is refused with 428 Precondition Required (SESSION.UPDATE_REQUIRES_CONFIRMATION); read the impact from GET /sessions/:id/references, then resend the identical body with a strategy. `propagate` rewrites those events to the new version; `keep-scheduled` leaves them exactly as prescribed and the edit reaches only future assignments. Ignored when nothing is scheduled.
     *
     * @type {EnSessionUpdateStrategy}
     * @memberof UpdateSessionDto
     */
    strategy?: EnSessionUpdateStrategy;

    /**
     * @type {Array<UpdateSessionExerciseDto>}
     * @memberof UpdateSessionDto
     */
    exercises?: Array<UpdateSessionExerciseDto>;
}
